module.exports = __webpack_public_path__ + "img/2013nianhui.32eead6c.png";